export const DefaultStateList = [
    { 'state': 'Alabama', 'a2': 'AL' },
    { 'state': 'Alaska', 'a2': 'AK' },
    { 'state': 'Arizona', 'a2': 'AZ' },
    { 'state': 'Arkansas', 'a2': 'AR' },
    { 'state': 'California', 'a2': 'CA' },
    { 'state': 'Colorado', 'a2': 'CO' },
    { 'state': 'Connecticut', 'a2': 'CT' },
    { 'state': 'Delaware', 'a2': 'DE' },
    { 'state': 'Florida', 'a2': 'FL' },
    { 'state': 'Georgia', 'a2': 'GA' },
    { 'state': 'Hawaii', 'a2': 'HI' },
    { 'state': 'Idaho', 'a2': 'ID' },
    { 'state': 'Illinois', 'a2': 'IL' },
    { 'state': 'Indiana', 'a2': 'IN' },
    { 'state': 'Iowa', 'a2': 'IA' },
    { 'state': 'Kansas', 'a2': 'KS' },
    { 'state': 'Kentucky', 'a2': 'KY' },
    { 'state': 'Louisiana', 'a2': 'LA' },
    { 'state': 'Maine', 'a2': 'ME' },
    { 'state': 'Maryland', 'a2': 'MD' },
    { 'state': 'Massachusetts', 'a2': 'MA' },
    { 'state': 'Michigan', 'a2': 'MI' },
    { 'state': 'Minnesota', 'a2': 'MN' },
    { 'state': 'Mississippi', 'a2': 'MS' },
    { 'state': 'Missouri', 'a2': 'MO' },
    { 'state': 'Montana', 'a2': 'MT' },
    { 'state': 'Nebraska', 'a2': 'NE' },
    { 'state': 'Nevada', 'a2': 'NV' },
    { 'state': 'New Hampshire', 'a2': 'NH' },
    { 'state': 'New Jersey', 'a2': 'NJ' },
    { 'state': 'New mexico', 'a2': 'NM' },
    { 'state': 'New York', 'a2': 'NY' },
    { 'state': 'North Carolina', 'a2': 'NC' },
    { 'state': 'North Dakota', 'a2': 'ND' },
    { 'state': 'Ohio', 'a2': 'OH' },
    { 'state': 'Oklahoma', 'a2': 'OK' },
    { 'state': 'Oregon', 'a2': 'OR' },
    { 'state': 'Pennsylvania', 'a2': 'PA' },
    { 'state': 'Rhode island', 'a2': 'RI' },
    { 'state': 'South carolina', 'a2': 'SC' },
    { 'state': 'South dakota', 'a2': 'SD' },
    { 'state': 'Tennessee', 'a2': 'TN' },
    { 'state': 'Texas', 'a2': 'TX' },
    { 'state': 'Utah', 'a2': 'UT' },
    { 'state': 'Vermont', 'a2': 'VT' },
    { 'state': 'Virginia', 'a2': 'VA' },
    { 'state': 'Washington', 'a2': 'WA' },
    { 'state': 'West Virginia', 'a2': 'WV' },
    { 'state': 'Wisconsin', 'a2': 'WI' },
    { 'state': 'Wyoming', 'a2': 'WY' },
    { 'state': 'Alberta', 'a2': 'AB' },
    { 'state': 'British Columbia', 'a2': 'BC' },
    { 'state': 'Manitoba', 'a2': 'MB' },
    { 'state': 'New Brunswick', 'a2': 'NB' },
    { 'state': 'Newfoundland and Labrador', 'a2': 'NL' },
    { 'state': 'Northwest Territories', 'a2': 'NT' },
    { 'state': 'Nova Scotia', 'a2': 'NS' },
    { 'state': 'Nunavut', 'a2': 'NU' },
    { 'state': 'Ontario', 'a2': 'ON' },
    { 'state': 'Prince Edward Island', 'a2': 'PE' },
    { 'state': 'Saskatchewan', 'a2': 'SK' },
    { 'state': 'Yukon', 'a2': 'YT' }
];
